import { useState, useEffect } from "react";
import { Col, Form, Modal, Row, Alert } from "react-bootstrap";
import { AddNewItem, UpdateItem, getItemsByProject } from "../../Services/item-services";
import SuccessAlertModal from "../Modals/successAlertModal";
import ConfirmAlertModal from "../Modals/confirmAlertModal";
import { useNavigate } from "react-router-dom";
import { twodecimal } from "../../functions/validations";
import { showSuccess, showWarning } from "../utility/ui/notifications/Toaster";
import { getLNProjectdata } from "../../Services/project-services";
import { SearchSelect } from "../utility/forms/inputs/search-select";
import ButtonModal from "../Modals/buttonModal";
import PropTypes from 'prop-types';

const AddEditItemMaster = (props) => {
  AddEditItemMaster.propTypes = {
    props: PropTypes.any,
    rowdata: PropTypes.object
  }

  if (props.rowdata.wld_status === "Active") {
    props.rowdata.wld_status = true;
  } else if (props.rowdata.wld_status === "Inactive") {
    props.rowdata.wld_status = false;
  }

  let action = props.action;
  let formName = "Item";

  const [showSuccessModel, setShowSuccessModel] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showConfirmModel, setshowConfirmModel] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [ProjectDetails, setProjectDetails] = useState([]);
  const [Projectdata, setProjectdata] = useState([]);
  const [Itemdata, setItemdata] = useState([]);
  const toggle = props.rowdata.wld_status === false ? "InactiveToggleLabel" : "activeToggleLabel";
  const [toggleClass, setToggleClass] = useState(action === "Edit" ? toggle : "activeToggleLabel");
  const history = useNavigate();
  let username = sessionStorage.getItem("UserName");


  const [ItemObj, setItemObj] = useState(
    action === "Edit"
      ? props.rowdata
      : {
        wld_status: true,
        wld_code: "",
        wld_itemcode: "",
        wld_description: "",
        wld_itemgroup: "",
        wld_itemtype: "",
        wld_weight: "",
        SK: "",
        PK: "Item",
        wld_createdby: "",
        wld_createdon: "",
        wld_updatedby: "",
        wld_updatedon: "",
        wld_ProjectNumber: "",
      }
  );

  const [error, setError] = useState({
    SK: {},
    PK: {},
    wld_status: {},
    wld_code: {},
    wld_itemcode: {},
    wld_description: {},
    wld_itemgroup: {},
    wld_itemtype: {},
    wld_weight: {},
    wld_createdby: {},
    wld_createdon: {},
    wld_updatedby: {},
    wld_updatedon: {},
    wld_ProjectNumber: {},
  });
  const modalOnClick = () => {
    history.push({
      pathname: "/",
      data: "setItem",
    });
  };

  const handleCloseSuccess = () => {
    setShowSuccessModel(false);
    props.onHide();
    props.setReload(!props.reload);
  };

  const handleCloseConf = () => {
    setshowConfirmModel(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setItemObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((prevState) => ({
      ...prevState,
    }));
  };

  const fetchprojectnumber = async (projectNo) => {
    const result = await getItemsByProject(projectNo);

    setProjectdata(result);

    setItemObj((prev) => ({
      ...prev,
      wld_code: projectNo,
    }));
    let filterprojectno = result?.map((a) => {
      return { item: a.item };
    });

    setItemdata(filterprojectno);
  };

  const handleSwitchChange = (e) => {
    if (e.target.checked) {
      setToggleClass("activeToggleLabel")
    } else {
      setToggleClass("inactiveToggleLabel")
    }

    setItemObj((prevState) => ({
      ...prevState,
      wld_status: e.target.checked,
    }));
  };

  const resetForm = () => {
    if (action === "Add") {
      setItemObj((prevState) => ({
        ...prevState,
        wld_status: true,
        wld_code: "",
        wld_itemcode: "",
        wld_description: "",
        wld_itemgroup: "",
        wld_itemtype: "",
        wld_weight: "",
        SK: "",
        wld_createdby: "",
        wld_createdon: "",
        wld_ProjectNumber: "",
        item: "",
        itemDesc: "",
        itemGroup: "",
        itemType: "",
      }));
    } else if (action === "Edit") {
      setItemObj((prevState) => ({
        ...prevState,
        PK: props.rowdata.PK,
        SK: props.rowdata.SK,
        wld_status: props.rowdata.wld_status,
        wld_code: props.rowdata.wld_code,
        wld_itemcode: props.rowdata.wld_itemcode,
        wld_description: props.rowdata.wld_description,
        wld_itemgroup: props.rowdata.wld_itemgroup,
        wld_itemtype: props.rowdata.wld_itemtype,
        wld_weight: props.rowdata.wld_weight,
        wld_createdby: props.rowdata.wld_createdby,
        wld_createdon: props.rowdata.wld_createdon,
        wld_ProjectNumber: props.rowdata.wld_ProjectNumber,
        item: props.rowdata.item,
        itemDesc: props.rowdata.itemDesc,
        itemGroup: props.rowdata.itemGroup,
        itemType: props.rowdata.itemType,
      }));
    }
    setError((prevState) => ({
      ...prevState,
      wld_code: {},
      wld_itemcode: {},
      SK: {},
    }));
  };

  const fetchProject = async () => {
    const result = await getLNProjectdata();
    setProjectDetails(result);
  };
  useEffect(() => {
    fetchProject();
  }, []);

  const validateItem = () => {
    let isError = false;
    if (!ItemObj.wld_weight.match(/^\d*(\.\d{0,2})*$/)) {
      ItemObj.wld_weight = "";
      isError = true;
      error.wld_weight = {
        status: true,
        message: "Only two digits allowed after the decimal point ",
      };
    } else if (ItemObj.wld_weight === "") {
      ItemObj.wld_weight = "";
      isError = true;
      error.wld_weight = {
        status: true,
        message: "Weight is required.",
      };
    }

    if (ItemObj.wld_status === "") {
      isError = true;
      error.wld_status = {
        status: true,
        message: "Status is required.",
      };
    }


    setError((prevState) => ({
      ...prevState,
      ...error,
    }));
    if (error.SK.status || error.wld_code.status || error.wld_itemcode.status) {
      isError = true;
    }
    return isError;
  };

  const handleAdd = (e) => {
    let result;
    if (ItemObj.wld_status === true) {
      ItemObj.wld_status = "Active";
    } else {
      ItemObj.wld_status = "Inactive";
    }
    if (action === "Add") {
      ItemObj.SK = ItemObj.wld_code;
      ItemObj.wld_createdby = username;

      result = AddNewItem(ItemObj);
    } else {
      ItemObj.wld_updatedby = ItemObj.wld_createdby;

      result = UpdateItem(ItemObj);
    }
    result
      .then((resp) => {
        if (action === "Edit") {
          showSuccess(`Selected Item  has been Updated successfully`);
        }
        if (resp.message === "Duplicate") {
          showWarning(resp.message);
        }
        else if (action === "Add") {
          showSuccess(`Selected Item has been Added successfully`);
        }
        props.setReload(!props.reload);
        setShowForm(false);
        props.onHide();
      })
      .catch((error) => {
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateItem()) {
      setshowConfirmModel(true);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAlertMessage("");
    }, 10000);
    return () => clearTimeout(timer);
  }, [alertMessage]);

  return (
    <>
      <SuccessAlertModal
        clickFunction={modalOnClick}
        msg={`Great! You've ${action}ed Item successfully.`}
        show={showSuccessModel}
        handleClose={handleCloseSuccess}
      />
      <ConfirmAlertModal
        action={action}
        handleYes={handleAdd}
        formName={formName}
        show={showConfirmModel}
        handleClose={handleCloseConf}
      />
      <Modal
        {...props}
        size="lg"
        centered
        className={
          showForm || showSuccessModel || showConfirmModel
            ? "opacity-0 userMasterModal"
            : "opacity-100 userMasterModal"
        }
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{action} Item Code </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit} autoComplete="off">
          <Modal.Body>
            <div className="px-2">
              <Row>
                <Col md={4}>
                  <Form.Group className="proj-input-select">
                    <div className="search-select">
                      <SearchSelect
                        required
                        data={ProjectDetails}
                        value={ItemObj.wld_code}
                        disabled={action === "Edit" ? true : false}
                        labelField={"wld_ProjectNumber"}
                        valueField={"wld_ProjectNumber"}
                        placeholder="Project Number"
                        onChange={(ProjectList) => {
                          fetchprojectnumber(ProjectList.value);
                          setItemObj((prevState) => ({
                            ...prevState,
                            wld_status: true,
                            wld_itemcode: "",
                            wld_description: "",
                            wld_itemgroup: "",
                            wld_itemtype: "",
                            wld_weight: "",
                            SK: "",
                            wld_createdby: "",
                            wld_createdon: "",
                            item: "",
                            itemDesc: "",
                            itemGroup: "",
                            itemType: "",
                          }));
                        }}
                      ></SearchSelect>
                    </div>
                    <Form.Label>Project Number</Form.Label>
                    <div className="required-text-select">
                      {error.wld_ProjectNumber.status && (
                        <Form.Text className="text-danger">
                          {error.wld_ProjectNumber.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>



                <Col md={4}>
                  <Form.Group className="proj-input-select">
                    <div className="search-select">
                      <SearchSelect
                        className="inspdrop"
                        data={Itemdata}
                        valueField={"item"}
                        disabled={action === "Edit" ? true : false}
                        value={ItemObj.wld_itemcode}
                        labelField={"item"}
                        onChange={(ItemList) => {
                          let a = Projectdata.filter((b) => {
                            return b.item === ItemList.value;
                          });
                          setItemObj((prev) => ({
                            ...prev,
                            wld_itemcode: ItemList.value,
                            wld_description: a[0].itemDesc,
                            wld_itemgroup: a[0].itemGroup,
                            wld_itemtype: a[0].itemType,
                          }));
                        }}
                      ></SearchSelect>
                    </div>
                    <Form.Label>Item Number</Form.Label>
                    <div className="required-text-select">
                      {error.wld_itemcode.status && (
                        <Form.Text className="text-danger">
                          {error.wld_itemcode.message}
                        </Form.Text>
                      )}
                    </div>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        id="wld_description"
                        name="wld_description"
                        type="text"
                        maxLength="50"
                        disabled="true"
                        className={`asterisk ${error.wld_description.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={ItemObj.wld_description}
                        onChange={(event, ItemObj) => {
                          setItemObj((prev) => ({
                            ...prev,
                            wld_description: ItemObj.itemDesc,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_description">
                        Description:
                      </Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;
                    {error.wld_description.status && (
                      <Form.Text className="text-danger">
                        {error.wld_description.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row
                className="gx-3"
                style={{
                  position: "relative",
                  bottom: "13px",
                }}
              >
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        id="wld_itemgroup"
                        name="wld_itemgroup"
                        type="text"
                        maxLength="50"
                        disabled="true"
                        className={`asterisk ${error.wld_itemgroup.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={ItemObj.wld_itemgroup}
                        onChange={(event, ItemObj) => {
                          setItemObj((prev) => ({
                            ...prev,
                            wld_itemgroup: ItemObj.itemGroup,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_itemgroup">
                        Item Group:
                      </Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;
                    {error.wld_itemgroup.status && (
                      <Form.Text className="text-danger">
                        {error.wld_itemgroup.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        id="wld_itemtype"
                        name="wld_itemtype"
                        type="text"
                        maxLength="50"
                        disabled
                        className={`asterisk ${error.wld_itemtype.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={ItemObj.wld_itemtype}
                        onChange={(event, ItemObj) => {
                          setItemObj((prev) => ({
                            ...prev,
                            wld_itemtype: ItemObj.itemType,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_itemtype">
                        Item Type:
                      </Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;
                    {error.wld_itemtype.status && (
                      <Form.Text className="text-danger">
                        {error.wld_itemtype.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        id="wld_weight"
                        name="wld_weight"
                        type="text"
                        maxLength="50"
                        className={`asterisk ${error.wld_weight.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={ItemObj.wld_weight}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = twodecimal(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            wld_weight: error,
                          }));
                        }}
                      />
                      <Form.Label htmlFor="wld_weight">
                        Weight of consumable (kg/Electrode):
                      </Form.Label>
                    </div>

                    {error.wld_weight.status && (
                      <div className="text-danger">
                        {error.wld_weight.message}
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row style={{ position: "relative", bottom: "30px" }}>
                <Col lg={4} md={12}>
                  <Form.Group className="form-switch-input mt-1">
                    <Form.Label className="fieldLabel mb-0">Status</Form.Label>
                    <Form.Switch
                      className={"semiBoldToggleButton " + toggleClass}
                      name="wld_status"
                      checked={ItemObj.wld_status}
                      onChange={handleSwitchChange}
                    />
                    <span className={"fieldLabel " + toggleClass}>
                      {ItemObj.wld_status ? "Active" : "Inactive"}
                    </span>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            {alertMessage && (
              <Alert className="alertBox" variant="warning">
                {alertMessage}
              </Alert>
            )}
          </Modal.Body>
          <Row>
            <ButtonModal action={action} resetForm={resetForm}></ButtonModal>
          </Row>
          <Row>
            <br></br>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AddEditItemMaster;
